<template>
  <div style="margin: 10px 20px;">
    <el-collapse v-model="activeNames">
    <el-collapse-item :title="showTitleName(1)" name="1">
      <div v-if="data.pendinG_CONFIRMATION">
        <div v-for="(item, index) in data.pendinG_CONFIRMATION.reservations" :key="index">
          <div class="container">
            <div>{{ item.bookingCode }}</div>
            <div :class="showBookingCodeWaitTime(item)">{{ convertsTime(item.waitTime) }}</div>
          </div>
        </div>
      </div>
    </el-collapse-item>
    <el-collapse-item :title="showTitleName(2)" name="2">
      <div v-if="data.cwT_PENDING_CANCELLATION">
        <div v-for="(item, index) in data.cwT_PENDING_CANCELLATION.reservations" :key="index">
          <div class="container">
            <div>{{ item.bookingCode }}</div>
            <div :class="showBookingCodeWaitTime(item)">{{ convertsTime(item.waitTime) }}</div>
          </div>
        </div>
      </div>
    </el-collapse-item>
    <el-collapse-item :title="showTitleName(3)" name="3">
      <div v-if="data.cwT_PENDING_CONFIRMATION">
        <div v-for="(item, index) in data.cwT_PENDING_CONFIRMATION.reservations" :key="index">
          <div class="container">
            <div>{{ item.bookingCode }}</div>
            <div :class="showBookingCodeWaitTime(item)">{{ convertsTime(item.waitTime) }}</div>
          </div>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
  </div>
</template>
<script>
import { getOrderWaitiMonitor} from "../../api/bookingData.js";
export default {
    data() {
      return {
        activeNames: ['1'],
        data:{},
        statusMap : {
          1: { key: 'pendinG_CONFIRMATION', text: 'PENDING_CONFIRMATION | 待确认' },
          2: { key: 'cwT_PENDING_CANCELLATION', text: 'CWT_PENDING_CANCELLATION | 待取消' },
          3: { key: 'cwT_PENDING_CONFIRMATION', text: 'CWT_PENDING_CONFIRMATION | 待处理' }
        }
      };
    },
    mounted() {
      this.getOrderWaitiMonitorData()
    },
    methods: {
      getOrderWaitiMonitorData(){
        let orderParam = {
        params: {
          daysAgo: 30,
        },
      };
      getOrderWaitiMonitor(orderParam)
        .then((res) => {
          if(res.code == 200){
            this.data = res.data.list;
          }
        });
      },
      showBookingCodeWaitTime(item){
        switch(true){
          case (item.waitTime >= 30 && item.waitTime < 1440):
            return 'failure20-row';
          case (item.waitTime > 1440):
            return 'failure100-row';
        }
      },
      convertsTime(time){
        const hours = Math.floor(time / 60); // 获取小时数
        const remainingMinutes = time % 60; // 获取剩余的分钟数
        return `${hours}hrs ${remainingMinutes}mins`;
      },
      showTitleName(val){
        const status = this.statusMap[val];
        if (status) {
          const dataItem = this.data[status.key];
          return dataItem ? `${status.text} (${dataItem.orderCount})` : status.text;
        }
      }
    }
}
</script>
<style scoped>
::v-deep .el-collapse-item__header.is-active{
    border-bottom-color:#161516;
}
::v-deep .el-collapse-item__header{
    background-color: #f2f2f2;
    height: 35px;
}
.container {
    display: grid;
    grid-template-columns: 1fr 1fr; /* 左右两列，等宽 */
    gap: 10px; /* 可选: 设置列间距 */
}
::v-deep .el-collapse-item__content{
  padding: 0 0 10px 20px;
}
.failure20-row {
  background-color: #ffff00;
}
.failure100-row {
  background-color: #ff0000;
}
</style>